import { styled } from "@mui/material";

export default styled("div")`
    .table {
        .table-row {
            &:hover {
                background-color: rgba(0, 0, 0, 0.04);
            }
        }
        
        .table-cell {
            padding: 12px 16px;
            border-bottom: 1px solid rgba(224, 224, 224, 1);
        }
        
        .table-value {
            font-size: 14px;
        }
        
        .MuiChip-root {
            font-weight: 500;
        }
        
        .MuiLink-root {
            font-weight: 500;
        }
        
        .MuiButton-root {
            min-width: 80px;
            font-size: 12px;
        }
    }
`;
